<div class="contenedor">
    <div>
        <h2 style="text-align: center; color: #003C8A;">
            <!--<mat-icon color="primary">
                picture_as_pdf
            </mat-icon>-->Crear Documento
        </h2>
    </div>
    <hr class="divider">
    <div class="form-group">
        <form [formGroup]="form">
            <mat-form-field appearance="outline" class="select-field">
                <mat-label>Documento</mat-label>
                <mat-select formControlName="documentType">
                  <mat-option *ngFor="let use of documentUses" [value]="use.idUsed">
                    {{ use.name }}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="select-field">
                <mat-label>Tipo de firma</mat-label>
                <mat-select formControlName="signingType">
                  <mat-option *ngFor="let type of signingTypes" [value]="type.id">
                    {{ type.name }}
                  </mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
    <div class="button-group">
        <button mat-raised-button color="accent" (click)="generarBorrador()" [disabled]="!form.valid">Borrador</button>
        <button mat-raised-button color="primary" (click)="generarDocumento()" [disabled]="!form.valid">Generar</button>
    </div>
</div>
